export default {
  welcome: 'Добро пожаловать',
  signInToAccount: 'Войдите в свой аккаунт',
  createNewAccount: 'Создайте новый аккаунт',
  noAccount: 'Нет аккаунта?',
  signUpAction: 'Зарегистрироваться',
  haveAccount: 'Уже есть аккаунт?',
  logInAction: 'Войти',
  loginTab: 'Вход',
  signUpTab: 'Регистрация',
  email: 'Email',
  emailPlaceholder: 'user@example.com',
  password: 'Пароль',
  passwordPlaceholder: '••••••••',
  confirmPassword: 'Подтвердите пароль',
  name: 'Имя',
  namePlaceholder: 'Иван Иванов',
  signIn: 'Войти',
  signingIn: 'Вход...',
  createAccount: 'Создать аккаунт',
  creatingAccount: 'Создание аккаунта...',
  agreeToTerms:
    'Я принимаю условия использования и политику конфиденциальности',
  agreeToTermsPrefix: 'Я принимаю',
  termsOfService: 'условия использования',
  agreeToTermsAnd: 'и',
  privacyPolicy: 'политику конфиденциальности',
  refundPolicy: 'политику возврата',
  pendingApproval: 'Ожидание подтверждения',
  pendingApprovalDescription:
    'Ваш запрос на вступление в организацию отправлен. Владелец организации рассмотрит его в ближайшее время.',
  refreshAfterApproval:
    'Проверьте статус после получения подтверждения, чтобы продолжить.',
  checkStatus: 'Проверить статус',
  checkingStatus: 'Проверяем статус...',
  backToLogin: 'Вернуться на страницу входа',
  pendingApprovalStillPending:
    'Ваша заявка всё ещё ожидает подтверждения администратором организации.',
  verifyEmailSentTitle: 'Подтвердите email',
  verifyEmailSentDescription:
    'Мы отправили ссылку для подтверждения на {{email}}. Перейдите по ней из почты, чтобы активировать аккаунт.',
  verifyEmailSentDescriptionNoEmail:
    'Мы отправили ссылку для подтверждения вам на email. Перейдите по ней из почты, чтобы активировать аккаунт.',
  verifyEmailResend: 'Отправить письмо ещё раз',
  verifyEmailResendCooldown: 'Повтор через {{seconds}} с',
  verifyEmailResent: 'Новое письмо отправлено.',
  verifyEmailLoading: 'Подтверждаем email…',
  verifyEmailExpired: 'Срок действия ссылки истёк',
  verifyEmailExpiredDescription:
    'Запросите новое письмо подтверждения и попробуйте снова.',
  verifyEmailInvalid: 'Ссылка больше недействительна',
  verifyEmailInvalidDescription:
    'Возможно, она уже была использована. Войдите, чтобы продолжить.',
  emailChangeConfirming: 'Подтверждаем новый email…',
  emailChangeDone: 'Теперь ваш email — {{email}}',
  emailChangeAlreadyDone: 'Этот email уже подтверждён',
  emailChangeAlreadyDoneDescription: 'Войдите с {{email}}.',
  emailChangeExpired: 'Срок действия ссылки истёк',
  emailChangeExpiredDescription:
    'Запросите новую ссылку в настройках аккаунта. Текущий email продолжает работать.',
  emailChangeInvalid: 'Ссылка больше не действует',
  emailChangeInvalidDescription:
    'Откройте последнюю отправленную ссылку или запросите новую в настройках аккаунта.',
  emailChangeTaken: 'Этот email уже занят',
  emailChangeTakenDescription:
    'Этот адрес теперь использует другой аккаунт. Текущий email продолжает работать.',
  emailChangeGoToSettings: 'Настройки аккаунта',
  verifyEmailGoToLogin: 'Логин',
  loginEmailNotVerified: 'Подтвердите email перед входом.',
  showPassword: 'Показать пароль',
  hidePassword: 'Скрыть пароль',
  validation: {
    nameMinLength: 'Имя должно быть не короче 2 символов',
    invalidEmail: 'Введите корректный email',
    passwordPolicy:
      'Пароль должен содержать от 8 до 50 символов, заглавные и строчные буквы, цифру и спецсимвол.',
    termsRequired: 'Необходимо принять условия использования',
    passwordsDoNotMatch: 'Пароли не совпадают',
  },
  errors: {
    invalidCredentials: 'Неверный email или пароль',
    emailInUse: 'Пользователь с таким email уже существует',
    invalidEmail: 'Введите корректный email',
    serverUnavailable: 'Не удалось подключиться к серверу. Попробуйте позже',
    networkError: 'Не удалось подключиться к серверу. Попробуйте позже',
    unknown: 'Не удалось выполнить операцию. Попробуйте позже',
  },
}
